import {
  fromIso8601DateTime,
  toLocaleTextAsDateTime,
} from "@/shared/lib/datetime";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { Typography } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";

export const OfferCargoReceptionDeadlineInfo = (props: {
  draftOfferCargo: Pick<FreightMatching.schemas.OfferCargo, "deadlineAt">;
}) => {
  return (
    <>
      <Typography
        variant="body1"
        fontWeight={700}
        mb={1}
        sx={{
          "::before": {
            content: '"■"',
            fontSize: "150%",
            marginRight: "2px",
          },
        }}
      >
        提案受付期限
      </Typography>
      <BaseKeyValue keyLabel="受付期限">
        {toLocaleTextAsDateTime(
          fromIso8601DateTime(props.draftOfferCargo.deadlineAt),
        )}
      </BaseKeyValue>
    </>
  );
};
